import * as i0 from '@angular/core';
import { input, computed, Component, ChangeDetectionStrategy, HostBinding, inject, output, signal, ViewChild } from '@angular/core';
import { NgClass, NgComponentOutlet, DOCUMENT } from '@angular/common';
import { NgxIcon } from '@digipay/ngx-icon';
function NgxInfoComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 7);
  }
  if (rf & 2) {
    let tmp_1_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("st-8 " + ((tmp_1_0 = ctx_r0.colors()) == null ? null : tmp_1_0.titleColor));
    i0.ɵɵproperty("textContent", ctx_r0.title());
  }
}
function NgxInfoComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_1_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("c-3 " + ((tmp_1_0 = ctx_r0.colors()) == null ? null : tmp_1_0.descriptionColor));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.description());
  }
}
function NgxInfoComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 6);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngComponentOutlet", ctx_r0.placeHolder1().component)("ngComponentOutletInputs", ctx_r0.placeHolder1().inputs);
  }
}
function NgxInfoComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 6);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngComponentOutlet", ctx_r0.placeHolder2().component)("ngComponentOutletInputs", ctx_r0.placeHolder2().inputs);
  }
}
function NgxInfoComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 6);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngComponentOutlet", ctx_r0.placeHolder3().component)("ngComponentOutletInputs", ctx_r0.placeHolder3().inputs);
  }
}
function NgxInfoComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_1_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("c-3 " + ((tmp_1_0 = ctx_r0.colors()) == null ? null : tmp_1_0.descriptionColor));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.description());
  }
}
function NgxInfoComponent_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 6);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngComponentOutlet", ctx_r0.placeHolder4().component)("ngComponentOutletInputs", ctx_r0.placeHolder4().inputs);
  }
}
const _c0 = ["canvasProgressBar"];
const _c1 = ["*"];
function NgxNodeComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("src", ctx_r0.imageSrc(), i0.ɵɵsanitizeUrl)("width", ctx_r0.imageSize())("height", ctx_r0.imageSize());
  }
}
function NgxNodeComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-icon", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r0.nameIcon())("iconSize", ctx_r0.iconSize())("classes", ctx_r0.iconClasses());
  }
}
function NgxNodeComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.numberClass());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.number());
  }
}
function NgxNodeComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ngx-indicator", 2);
    i0.ɵɵelement(1, "ngx-circle-progress", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("size", ctx_r0.pixelSize());
    i0.ɵɵadvance();
    i0.ɵɵproperty("size", ctx_r0.progressSize())("progressPercentage", 65);
  }
}
function NgxNodeComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 7);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(ctx_r0.centerCircleStyle());
  }
}
const _c2 = a0 => ({
  "mt-tiny": a0
});
function NgxCircleStepComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-info", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r0.info().title)("state", ctx_r0.info().state)("type", ctx_r0.info().type)("showDescription", ctx_r0.info().showDescription)("description", ctx_r0.info().description)("placeHolder1", ctx_r0.info().placeHolder1)("placeHolder2", ctx_r0.info().placeHolder2)("placeHolder3", ctx_r0.info().placeHolder3)("placeHolder4", ctx_r0.info().placeHolder4)("ngClass", i0.ɵɵpureFunction1(10, _c2, ctx_r0.size() === "lg"));
  }
}
function NgxCircleStepComponent_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-connector", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("type", ctx_r0.connector().type)("state", ctx_r0.connector().state)("orientation", ctx_r0.type());
  }
}
function NgxCircleStepComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelement(1, "ngx-node", 3);
    i0.ɵɵtemplate(2, NgxCircleStepComponent_Conditional_2_Conditional_2_Template, 1, 3, "ngx-connector", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_2_0;
    let tmp_4_0;
    let tmp_5_0;
    let tmp_6_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.nodeClass());
    i0.ɵɵadvance();
    i0.ɵɵproperty("type", (tmp_2_0 = ctx_r0.node()) == null ? null : tmp_2_0.type)("size", ctx_r0.size())("state", (tmp_4_0 = ctx_r0.node()) == null ? null : tmp_4_0.state)("icon", (tmp_5_0 = ctx_r0.node()) == null ? null : tmp_5_0.icon)("number", (tmp_6_0 = ctx_r0.node()) == null ? null : tmp_6_0.number);
    i0.ɵɵadvance();
    i0.ɵɵconditional(2, ctx_r0.connector() ? 2 : -1);
  }
}
const _c3 = a0 => ({
  "linear": a0
});
const _c4 = () => [];
function NgxLinearStepComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(ctx_r0.style());
  }
}
function NgxLinearStepComponent_Conditional_2_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-linear-progress-atom", 3);
  }
  if (rf & 2) {
    const i_r2 = ctx.$index;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("state", i_r2 < ctx_r0.currentStep() ? "done" : "default");
  }
}
function NgxLinearStepComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, NgxLinearStepComponent_Conditional_2_For_1_Template, 1, 1, "ngx-linear-progress-atom", 3, i0.ɵɵrepeaterTrackByIndex);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(i0.ɵɵpureFunction0(0, _c4).constructor(ctx_r0.totalSteps()));
  }
}
function NgxStepperComponent_Conditional_1_For_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ngx-circle-step", 2);
    i0.ɵɵlistener("click", function NgxStepperComponent_Conditional_1_For_1_Template_ngx_circle_step_click_0_listener($event) {
      const step_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.handleStepClicked($event, step_r2.id));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const step_r2 = ctx.$implicit;
    const i_r4 = ctx.$index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleMap(ctx_r2.stepStyle(i_r4));
    i0.ɵɵproperty("size", ctx_r2.size())("info", step_r2.info)("type", ctx_r2.orientation())("node", step_r2.circleNode)("direction", ctx_r2.direction())("connector", ctx_r2.circleConnector(step_r2, i_r4));
  }
}
function NgxStepperComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, NgxStepperComponent_Conditional_1_For_1_Template, 1, 8, "ngx-circle-step", 1, i0.ɵɵrepeaterTrackByIndex);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r2.steps());
  }
}
function NgxStepperComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelement(1, "ngx-info", 4)(2, "ngx-linear-step", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_1_0;
    let tmp_3_0;
    let tmp_4_0;
    let tmp_6_0;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", (tmp_1_0 = ctx_r2.current()) == null ? null : tmp_1_0.info == null ? null : tmp_1_0.info.title)("showDescription", true)("placeHolder2", (tmp_3_0 = ctx_r2.current()) == null ? null : tmp_3_0.info == null ? null : tmp_3_0.info.placeHolder2)("description", (tmp_4_0 = ctx_r2.current()) == null ? null : tmp_4_0.info == null ? null : tmp_4_0.info.description);
    i0.ɵɵadvance();
    i0.ɵɵproperty("type", ctx_r2.linearType())("totalSteps", (tmp_6_0 = ctx_r2.steps()) == null ? null : tmp_6_0.length)("currentStep", ctx_r2.currentStep());
  }
}
let NgxConnectorComponent = /*#__PURE__*/(() => {
  class NgxConnectorComponent {
    constructor() {
      this.orientation = input('horizontal');
      this.state = input('default');
      this.type = input('linear');
      this.connectorClass = computed(() => 'connector-' + this.type() + '-' + this.orientation() + '-' + this.state() + ' radius-small');
    }
    static {
      this.ɵfac = function NgxConnectorComponent_Factory(t) {
        return new (t || NgxConnectorComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxConnectorComponent,
        selectors: [["ngx-connector"]],
        hostVars: 8,
        hostBindings: function NgxConnectorComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("display", "flex")("width", ctx.orientation() === "horizontal" ? "100%" : "fit-content")("height", ctx.orientation() === "horizontal" ? "fit-content" : "unset")("flex", ctx.orientation() === "vertical" ? "1" : "unset");
          }
        },
        inputs: {
          orientation: [i0.ɵɵInputFlags.SignalBased, "orientation"],
          state: [i0.ɵɵInputFlags.SignalBased, "state"],
          type: [i0.ɵɵInputFlags.SignalBased, "type"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 2,
        template: function NgxConnectorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "div");
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.connectorClass());
          }
        },
        styles: ["[_ngcontent-%COMP%]:root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root{--base-font-feature-settings: \"ss01\" on, \"liga\" off, \"clig\" off}.connector-dot-horizontal-default[_ngcontent-%COMP%]{display:flex;--s: 6px;min-width:38px;background:radial-gradient(circle closest-side,var(--onback-shade-80) 98%,transparent) 0 0/var(--s) 100%,linear-gradient(90deg,var(--onback-shade-80) 50%,transparent 0) calc(var(--s) / 2) 0/calc(2 * var(--s)) 100%;flex:1;height:2.25px}.connector-dot-horizontal-current[_ngcontent-%COMP%]{display:flex;--s: 6px;min-width:38px;background:radial-gradient(circle closest-side,var(--surface-brand) 98%,transparent) 0 0/var(--s) 100%,linear-gradient(90deg,var(--surface-brand) 50%,transparent 0) calc(var(--s) / 2) 0/calc(2 * var(--s)) 100%;flex:1;height:2.25px}.connector-dot-horizontal-done[_ngcontent-%COMP%]{display:flex;--s: 6px;min-width:38px;background:radial-gradient(circle closest-side,var(--surface-success) 98%,transparent) 0 0/var(--s) 100%,linear-gradient(90deg,var(--surface-success) 50%,transparent 0) calc(var(--s) / 2) 0/calc(2 * var(--s)) 100%;flex:1;height:2.25px}.connector-dot-horizontal-failed[_ngcontent-%COMP%]{display:flex;--s: 6px;min-width:38px;background:radial-gradient(circle closest-side,var(--surface-error) 98%,transparent) 0 0/var(--s) 100%,linear-gradient(90deg,var(--surface-error) 50%,transparent 0) calc(var(--s) / 2) 0/calc(2 * var(--s)) 100%;flex:1;height:2.25px}.connector-dot-horizontal-warning[_ngcontent-%COMP%]{display:flex;--s: 6px;min-width:38px;background:radial-gradient(circle closest-side,var(--surface-warning) 98%,transparent) 0 0/var(--s) 100%,linear-gradient(90deg,var(--surface-warning) 50%,transparent 0) calc(var(--s) / 2) 0/calc(2 * var(--s)) 100%;flex:1;height:2.25px}.connector-linear-horizontal-default[_ngcontent-%COMP%]{display:flex;background-color:var(--onback-shade-80);min-width:38px;flex:1;height:2.25px}.connector-linear-horizontal-current[_ngcontent-%COMP%]{display:flex;background-color:var(--surface-brand);min-width:38px;flex:1;height:2.25px}.connector-linear-horizontal-done[_ngcontent-%COMP%]{display:flex;background-color:var(--surface-success);min-width:38px;flex:1;height:2.25px}.connector-linear-horizontal-failed[_ngcontent-%COMP%]{display:flex;background-color:var(--surface-error);min-width:38px;flex:1;height:2.25px}.connector-linear-horizontal-warning[_ngcontent-%COMP%]{display:flex;background-color:var(--surface-warning);min-width:38px;flex:1;height:2.25px}.connector-dot-vertical-default[_ngcontent-%COMP%]{display:flex;--s: 6px;min-height:38px;background:radial-gradient(circle closest-side,var(--onback-shade-80) 98%,transparent) 0 0/100% var(--s),linear-gradient(var(--onback-shade-80) 50%,transparent 0) 0 calc(var(--s) / 2)/100% calc(2 * var(--s));width:2.25px;flex:1}.connector-dot-vertical-current[_ngcontent-%COMP%]{display:flex;--s: 6px;min-height:38px;background:radial-gradient(circle closest-side,var(--surface-brand) 98%,transparent) 0 0/100% var(--s),linear-gradient(var(--surface-brand) 50%,transparent 0) 0 calc(var(--s) / 2)/100% calc(2 * var(--s));width:2.25px;flex:1}.connector-dot-vertical-done[_ngcontent-%COMP%]{display:flex;--s: 6px;min-height:38px;background:radial-gradient(circle closest-side,var(--surface-success) 98%,transparent) 0 0/100% var(--s),linear-gradient(var(--surface-success) 50%,transparent 0) 0 calc(var(--s) / 2)/100% calc(2 * var(--s));width:2.25px;flex:1}.connector-dot-vertical-failed[_ngcontent-%COMP%]{display:flex;--s: 6px;min-height:38px;background:radial-gradient(circle closest-side,var(--surface-error) 98%,transparent) 0 0/100% var(--s),linear-gradient(var(--surface-error) 50%,transparent 0) 0 calc(var(--s) / 2)/100% calc(2 * var(--s));width:2.25px;flex:1}.connector-dot-vertical-warning[_ngcontent-%COMP%]{display:flex;--s: 6px;min-height:38px;background:radial-gradient(circle closest-side,var(--surface-warning) 98%,transparent) 0 0/100% var(--s),linear-gradient(var(--surface-warning) 50%,transparent 0) 0 calc(var(--s) / 2)/100% calc(2 * var(--s));width:2.25px;flex:1}.connector-linear-vertical-default[_ngcontent-%COMP%]{display:flex;background-color:var(--onback-shade-80);min-height:38px;width:2.25px;flex:1}.connector-linear-vertical-current[_ngcontent-%COMP%]{display:flex;background-color:var(--surface-brand);min-height:38px;width:2.25px;flex:1}.connector-linear-vertical-done[_ngcontent-%COMP%]{display:flex;background-color:var(--surface-success);min-height:38px;width:2.25px;flex:1}.connector-linear-vertical-failed[_ngcontent-%COMP%]{display:flex;background-color:var(--surface-error);min-height:38px;width:2.25px;flex:1}.connector-linear-vertical-warning[_ngcontent-%COMP%]{display:flex;background-color:var(--surface-warning);min-height:38px;width:2.25px;flex:1}"],
        changeDetection: 0
      });
    }
  }
  return NgxConnectorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxInfoComponent = /*#__PURE__*/(() => {
  class NgxInfoComponent {
    constructor() {
      this.title = input.required();
      this.description = input();
      this.type = input('vertical');
      this.state = input('default');
      this.showDescription = input(false);
      this.placeHolder1 = input();
      this.placeHolder2 = input();
      this.placeHolder3 = input();
      this.placeHolder4 = input();
      this.titleClasses = computed(() => ({
        'gap-tiny': this.type() === 'horizontal',
        'flex-column gap-low': this.type() === 'vertical'
      }));
      this.colors = computed(() => {
        switch (this.state()) {
          case 'next-step':
            return {
              titleColor: 'text-onback-low',
              descriptionColor: 'text-onback-disabled'
            };
          case 'current':
            return {
              titleColor: 'text-onback-brand',
              descriptionColor: 'text-onback-medium'
            };
          case 'done':
            return {
              titleColor: 'text-onback-success',
              descriptionColor: 'text-onback-medium'
            };
          default:
            return {
              titleColor: 'text-onback-high',
              descriptionColor: 'text-onback-low'
            };
        }
      });
      this.width = '100%';
    }
    static {
      this.ɵfac = function NgxInfoComponent_Factory(t) {
        return new (t || NgxInfoComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxInfoComponent,
        selectors: [["ngx-info"]],
        hostVars: 2,
        hostBindings: function NgxInfoComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("width", ctx.width);
          }
        },
        inputs: {
          title: [i0.ɵɵInputFlags.SignalBased, "title"],
          description: [i0.ɵɵInputFlags.SignalBased, "description"],
          type: [i0.ɵɵInputFlags.SignalBased, "type"],
          state: [i0.ɵɵInputFlags.SignalBased, "state"],
          showDescription: [i0.ɵɵInputFlags.SignalBased, "showDescription"],
          placeHolder1: [i0.ɵɵInputFlags.SignalBased, "placeHolder1"],
          placeHolder2: [i0.ɵɵInputFlags.SignalBased, "placeHolder2"],
          placeHolder3: [i0.ɵɵInputFlags.SignalBased, "placeHolder3"],
          placeHolder4: [i0.ɵɵInputFlags.SignalBased, "placeHolder4"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 12,
        vars: 8,
        consts: [["dir", "rtl", 1, "d-flex", "flex-column", "gap-minus"], [1, "d-flex", 3, "ngClass"], [1, "d-flex", "align-items-center", "justify-content-space-between", "gap-medium", "w-100"], [1, "d-flex", "align-items-center", "gap-small"], [3, "textContent", "class"], [3, "class"], [3, "ngComponentOutlet", "ngComponentOutletInputs"], [3, "textContent"]],
        template: function NgxInfoComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3);
            i0.ɵɵtemplate(4, NgxInfoComponent_Conditional_4_Template, 1, 3, "span", 4)(5, NgxInfoComponent_Conditional_5_Template, 2, 3, "span", 5)(6, NgxInfoComponent_Conditional_6_Template, 1, 2, "ng-container", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "div", 3);
            i0.ɵɵtemplate(8, NgxInfoComponent_Conditional_8_Template, 1, 2, "ng-container", 6)(9, NgxInfoComponent_Conditional_9_Template, 1, 2, "ng-container", 6);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(10, NgxInfoComponent_Conditional_10_Template, 2, 3, "span", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(11, NgxInfoComponent_Conditional_11_Template, 1, 2, "ng-container", 6);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.titleClasses());
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(4, ctx.title() ? 4 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(5, ctx.showDescription() && ctx.description() && ctx.type() === "horizontal" ? 5 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(6, ctx.placeHolder1() ? 6 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(8, ctx.placeHolder2() ? 8 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(9, ctx.placeHolder3() ? 9 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(10, ctx.showDescription() && ctx.description() && ctx.type() === "vertical" ? 10 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(11, ctx.placeHolder4() ? 11 : -1);
          }
        },
        dependencies: [NgClass, NgComponentOutlet],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return NgxInfoComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxCircleProgressComponent = /*#__PURE__*/(() => {
  class NgxCircleProgressComponent {
    constructor() {
      this.document = inject(DOCUMENT);
      this.timer = input(0);
      this.progressPercentage = input(0);
      this.size = input(120);
      this.timerFinished = output();
      this.WAITING_STEPPER_STATE_COLOR = signal({});
      this.curPercent = 0;
      const root = this.document.documentElement;
      this.WAITING_STEPPER_STATE_COLOR.set({
        PROGRESS: getComputedStyle(root).getPropertyValue('--surface-brand'),
        SUCCESS: getComputedStyle(root).getPropertyValue('--surface-success'),
        FAILED: getComputedStyle(root).getPropertyValue('--surface-error')
      });
    }
    ngAfterViewInit() {
      this.animateDraw();
    }
    clear() {
      this.canvasContext?.clearRect(0, 0, this.canvasContext.canvas.width, this.canvasContext.canvas.height);
    }
    drawCircle(percentage) {
      const startAngle = -Math.PI / 2;
      const endAngle = startAngle + percentage / 100 * 2 * Math.PI;
      this.canvasContext = this.progressCanvas.nativeElement.getContext('2d');
      this.canvasContext.lineWidth = this.size();
      this.canvasContext.beginPath();
      this.canvasContext.arc(this.size() / 2, this.size() / 2, this.size() / 2, startAngle, endAngle);
      this.canvasContext.strokeStyle = this.WAITING_STEPPER_STATE_COLOR()['PROGRESS'];
      this.canvasContext.stroke();
    }
    animateDraw() {
      this.clear();
      this.drawCircle(this.curPercent);
      this.curPercent++;
      if (this.curPercent > this.progressPercentage()) {
        return;
      }
      if (this.timer()) {
        setTimeout(() => {
          requestAnimationFrame(() => this.animateDraw());
        }, this.timer() * 1000 / this.progressPercentage());
      } else {
        requestAnimationFrame(() => this.animateDraw());
      }
    }
    static {
      this.ɵfac = function NgxCircleProgressComponent_Factory(t) {
        return new (t || NgxCircleProgressComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxCircleProgressComponent,
        selectors: [["ngx-circle-progress"]],
        viewQuery: function NgxCircleProgressComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.progressCanvas = _t.first);
          }
        },
        inputs: {
          timer: [i0.ɵɵInputFlags.SignalBased, "timer"],
          progressPercentage: [i0.ɵɵInputFlags.SignalBased, "progressPercentage"],
          size: [i0.ɵɵInputFlags.SignalBased, "size"]
        },
        outputs: {
          timerFinished: "timerFinished"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 3,
        vars: 2,
        consts: [["canvasProgressBar", ""], [1, "ngx-circle-progress"], [3, "width", "height"]],
        template: function NgxCircleProgressComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵelement(1, "canvas", 2, 0);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("width", ctx.size())("height", ctx.size());
          }
        },
        styles: ["[_nghost-%COMP%]{display:flex;width:fit-content;height:fit-content}.ngx-circle-progress[_ngcontent-%COMP%]{display:flex;width:fit-content;height:fit-content}.ngx-circle-progress[_ngcontent-%COMP%]   canvas[_ngcontent-%COMP%]{border-radius:50%}"],
        changeDetection: 0
      });
    }
  }
  return NgxCircleProgressComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxIndicatorComponent = /*#__PURE__*/(() => {
  class NgxIndicatorComponent {
    constructor() {
      this.color = input('blue');
      this.size = input('120px');
      this.style = computed(() => {
        return {
          width: this.size(),
          height: this.size()
        };
      });
      this.borderStyle = computed(() => ({
        backgroundImage: `repeating-conic-gradient(transparent 0deg 10deg, ${this.color()} 10deg 15deg)`,
        width: 'inherit',
        height: 'inherit'
      }));
    }
    static {
      this.ɵfac = function NgxIndicatorComponent_Factory(t) {
        return new (t || NgxIndicatorComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxIndicatorComponent,
        selectors: [["ngx-indicator"]],
        inputs: {
          color: [i0.ɵɵInputFlags.SignalBased, "color"],
          size: [i0.ɵɵInputFlags.SignalBased, "size"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 4,
        consts: [[1, "ngx-indicator", "d-flex", "justify-content-center", "align-items-center"], [1, "ngx-indicator-border"]],
        template: function NgxIndicatorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵelement(2, "div", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵstyleMap(ctx.style());
            i0.ɵɵadvance(2);
            i0.ɵɵstyleMap(ctx.borderStyle());
          }
        },
        styles: [".ngx-indicator[_ngcontent-%COMP%]{border-radius:50%;position:relative;overflow:hidden}.ngx-indicator-border[_ngcontent-%COMP%]{position:absolute;top:0;left:0;-webkit-mask-image:radial-gradient(circle,transparent 0%,transparent 50%,black 50%,black 80%);mask-image:radial-gradient(circle,transparent 0%,transparent 50%,black 50%,black 80%)}"],
        changeDetection: 0
      });
    }
  }
  return NgxIndicatorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var StatusIconEnum = /*#__PURE__*/function (StatusIconEnum) {
  StatusIconEnum["FAILED_MD"] = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAABCcAAAQnAEmzTo0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABtSURBVHgB7ZTBCQAhDATDVXAlpP+mrpQ9BB/5qDG66sOF/NYZUInIzZEB8Kah9HP5y6OOvpp+W2IEaEkMHG5B4aBGOmHJMLwGmgavSObBC5Iu+CO7Q70i6iNTv6kHEJaAvSrAXnZGwlnXN8vzA9Xkv9CFKrtTAAAAAElFTkSuQmCC";
  StatusIconEnum["FAILED_LG"] = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAABCcAAAQnAEmzTo0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACcSURBVHgB7ZZtCoAgDIZHJ/AIHsEjef8/HmEpGZRQbTpbwR4Y/endEyM/AAzjbRDR5Yq5PDDpzpZAroQb5RkY2dBkHTUL9WuPkOSNdCcClTqqxJFfSFPPuANVznlXTC4upTSeJiXI50kf5HOlBDlbusDXURm1ys+FGssJNTYQTkMxOZ6PRVKjG/n/jsXRi4AHDnXckTUqgaxhDLMCmxIwhuE8S5sAAAAASUVORK5CYII=";
  StatusIconEnum["SUCCESS_MD"] = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAABCcAAAQnAEmzTo0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABpSURBVHgB7ZHBCcAgEAS3hJRgaZaQEuwkpaSElJB0srmHEBEJPvbAxw3sT2dAgSBYApLJdtouqKnymx8bVAzkGSrWldvh3Va85Km5eEjljaSMIlS+eR+hx4d2EUrlP5EMNTXyuMiDYIoXh34I3T7S4ukAAAAASUVORK5CYII=";
  StatusIconEnum["SUCCESS_LG"] = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAABCcAAAQnAEmzTo0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACgSURBVHgB7ZNBDYUwEEQ3X8GXgASkIAEJOAAJSMABFnAADpCAhGFIOEBToIduA8m+ZNJLd1/abkUMw3g7ACpmZnrmLymgqMaZ1t3zk8hsUi6NpMRzUuzXnYkW35ayIGeKwL3RpMWhwXj3FRDzelnUOY28csR+UxaWnoYnObQGiQ2aKzm0p/dCvqhKH+S60gC5nvRGri915BMzJJMahhHCChlb8y8V3nutAAAAAElFTkSuQmCC";
  return StatusIconEnum;
}(StatusIconEnum || {});
let NgxNodeComponent = /*#__PURE__*/(() => {
  class NgxNodeComponent {
    constructor() {
      this.type = input('node');
      this.size = input('md');
      this.state = input('default');
      this.icon = input('bnpl');
      this.number = input(1);
      this.classes = computed(() => ({
        'border-400': this.size() === 'md' && (this.state() === 'default' || this.type() === 'node' && this.state() === 'current'),
        'border-500': this.size() === 'lg' && (this.state() === 'default' || this.type() === 'node' && this.state() === 'current'),
        'border-color-tint': this.state() === 'default',
        'border-color-brand': this.type() === 'node' && this.state() === 'current',
        'surface-brand': this.type() !== 'node' && this.state() === 'current',
        'surface-success': this.state() === 'done',
        'surface-error': this.state() === 'failed',
        'text-oninvert-high': this.type() === 'number' && this.state() === 'current'
      }));
      this.pixelSize = computed(() => this.size() === 'md' ? '24px' : '32px');
      this.style = computed(() => ({
        'width': this.pixelSize(),
        'height': this.pixelSize()
      }));
      this.showIcon = computed(() => this.state() === 'warning' || this.type() === 'icon');
      this.nameIcon = computed(() => {
        return this.state() === 'warning' ? 'info-circle' : this.icon();
      });
      this.iconSize = computed(() => {
        if (this.state() === 'warning') {
          return this.size() === 'md' ? '32px' : '42px';
        }
        return this.size() === 'md' ? '16px' : '20px';
      });
      this.iconClasses = computed(() => {
        if (this.state() === 'warning') {
          return 'text-onback-warning';
        }
        return this.state() === 'default' ? 'text-onback-low' : 'text-oninvert-high';
      });
      this.showLoading = computed(() => this.type() === 'node' && this.state() === 'loading');
      this.progressSize = computed(() => this.size() === 'md' ? 12 : 16);
      this.numberClass = computed(() => ({
        'number-md': this.size() === 'md',
        'number-md-default': this.size() === 'md' && this.state() === 'default',
        'number-md-current': this.size() === 'md' && this.state() === 'current',
        'number-lg': this.size() === 'lg',
        'number-lg-default': this.size() === 'lg' && this.state() === 'default',
        'number-lg-current': this.size() === 'lg' && this.state() === 'current'
      }));
      this.showCenterCircle = computed(() => this.type() === 'node' && this.state() === 'current');
      this.centerCircleStyle = computed(() => ({
        width: this.iconSize(),
        height: this.iconSize()
      }));
      this.showImage = computed(() => this.state() === 'done' || this.state() === 'failed');
      this.imageSrc = computed(() => {
        if (this.state() === 'done' && this.size() === 'md') {
          return StatusIconEnum.SUCCESS_MD;
        } else if (this.state() === 'done' && this.size() === 'lg') {
          return StatusIconEnum.SUCCESS_LG;
        } else if (this.state() === 'failed' && this.size() === 'md') {
          return StatusIconEnum.FAILED_MD;
        } else {
          return StatusIconEnum.FAILED_LG;
        }
      });
      this.imageSize = computed(() => this.size() === 'md' ? 16 : 20);
      this.showNumber = computed(() => this.type() === 'number' && !this.showImage() && !this.showIcon());
    }
    static {
      this.ɵfac = function NgxNodeComponent_Factory(t) {
        return new (t || NgxNodeComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxNodeComponent,
        selectors: [["ngx-node"]],
        inputs: {
          type: [i0.ɵɵInputFlags.SignalBased, "type"],
          size: [i0.ɵɵInputFlags.SignalBased, "size"],
          state: [i0.ɵɵInputFlags.SignalBased, "state"],
          icon: [i0.ɵɵInputFlags.SignalBased, "icon"],
          number: [i0.ɵɵInputFlags.SignalBased, "number"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 6,
        vars: 6,
        consts: [["dir", "rtl", 1, "ngx-node", "d-flex", "justify-content-center", "align-items-center", "radius-big", 3, "ngClass"], ["alt", "icon", 3, "src", "width", "height"], ["color", "#1159FC", 3, "size"], [1, "surface-brand", "radius-big", 3, "style"], ["type", "bold", 3, "name", "iconSize", "classes"], [1, "number", 3, "ngClass"], [3, "size", "progressPercentage"], [1, "surface-brand", "radius-big"]],
        template: function NgxNodeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, NgxNodeComponent_Conditional_1_Template, 1, 3, "img", 1)(2, NgxNodeComponent_Conditional_2_Template, 1, 3)(3, NgxNodeComponent_Conditional_3_Template, 2, 2)(4, NgxNodeComponent_Conditional_4_Template, 2, 3, "ngx-indicator", 2)(5, NgxNodeComponent_Conditional_5_Template, 1, 2, "div", 3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵstyleMap(ctx.style());
            i0.ɵɵproperty("ngClass", ctx.classes());
            i0.ɵɵadvance();
            i0.ɵɵconditional(1, ctx.showImage() ? 1 : ctx.showIcon() ? 2 : ctx.showNumber() ? 3 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(4, ctx.showLoading() ? 4 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(5, ctx.showCenterCircle() ? 5 : -1);
          }
        },
        dependencies: [NgClass, NgxIcon, NgxIndicatorComponent, NgxCircleProgressComponent],
        styles: ["[_ngcontent-%COMP%]:root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root{--base-font-feature-settings: \"ss01\" on, \"liga\" off, \"clig\" off}.ngx-node[_ngcontent-%COMP%]{box-sizing:border-box}.ngx-node[_ngcontent-%COMP%]   .number[_ngcontent-%COMP%]{text-align:center;font-style:normal;font-feature-settings:var(--base-font-feature-settings),\"ss07\" on!important}.ngx-node[_ngcontent-%COMP%]   .number-md[_ngcontent-%COMP%]{font-size:12px;line-height:20px}.ngx-node[_ngcontent-%COMP%]   .number-md-default[_ngcontent-%COMP%]{font-weight:370}.ngx-node[_ngcontent-%COMP%]   .number-md-current[_ngcontent-%COMP%]{font-weight:600}.ngx-node[_ngcontent-%COMP%]   .number-lg[_ngcontent-%COMP%]{font-size:16px}.ngx-node[_ngcontent-%COMP%]   .number-lg-default[_ngcontent-%COMP%]{font-weight:370;line-height:28px}.ngx-node[_ngcontent-%COMP%]   .number-lg-current[_ngcontent-%COMP%]{font-weight:600;line-height:32px}", "[_nghost-%COMP%]{display:flex;width:fit-content;height:fit-content}"],
        changeDetection: 0
      });
    }
  }
  return NgxNodeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxCircleStepComponent = /*#__PURE__*/(() => {
  class NgxCircleStepComponent {
    constructor() {
      this.type = input('horizontal');
      this.size = input('md');
      this.node = input({
        type: 'node',
        state: 'default'
      });
      this.connector = input({
        type: 'dot',
        state: 'default'
      });
      this.info = input();
      this.direction = input('rtl');
      this.nodeClass = computed(() => this.type() === 'horizontal' ? 'flex-row' : 'flex-column');
      this.stepClass = computed(() => this.type() === 'horizontal' ? 'flex-column gap-low' : 'flex-row-reverse justify-content-flex-end gap-minus');
    }
    static {
      this.ɵfac = function NgxCircleStepComponent_Factory(t) {
        return new (t || NgxCircleStepComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxCircleStepComponent,
        selectors: [["ngx-circle-step"]],
        inputs: {
          type: [i0.ɵɵInputFlags.SignalBased, "type"],
          size: [i0.ɵɵInputFlags.SignalBased, "size"],
          node: [i0.ɵɵInputFlags.SignalBased, "node"],
          connector: [i0.ɵɵInputFlags.SignalBased, "connector"],
          info: [i0.ɵɵInputFlags.SignalBased, "info"],
          direction: [i0.ɵɵInputFlags.SignalBased, "direction"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 3,
        vars: 4,
        consts: [[1, "d-flex", 3, "ngClass", "dir"], [1, "w-100", 3, "title", "state", "type", "showDescription", "description", "placeHolder1", "placeHolder2", "placeHolder3", "placeHolder4", "ngClass"], [1, "d-flex", "align-items-center", "gap-tiny", 3, "ngClass"], [3, "type", "size", "state", "icon", "number"], [3, "type", "state", "orientation"]],
        template: function NgxCircleStepComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, NgxCircleStepComponent_Conditional_1_Template, 1, 12, "ngx-info", 1)(2, NgxCircleStepComponent_Conditional_2_Template, 3, 7, "div", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.stepClass())("dir", ctx.direction());
            i0.ɵɵadvance();
            i0.ɵɵconditional(1, ctx.info() ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(2, ctx.node() ? 2 : -1);
          }
        },
        dependencies: [NgxNodeComponent, NgxConnectorComponent, NgClass, NgxInfoComponent],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return NgxCircleStepComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxLinearProgressAtomComponent = /*#__PURE__*/(() => {
  class NgxLinearProgressAtomComponent {
    constructor() {
      this.state = input('default');
      this.classes = computed(() => this.state() === 'default' ? 'default' : 'surface-brand');
    }
    static {
      this.ɵfac = function NgxLinearProgressAtomComponent_Factory(t) {
        return new (t || NgxLinearProgressAtomComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxLinearProgressAtomComponent,
        selectors: [["ngx-linear-progress-atom"]],
        inputs: {
          state: [i0.ɵɵInputFlags.SignalBased, "state"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 1,
        consts: [[1, "linear-progress-atom", 3, "ngClass"]],
        template: function NgxLinearProgressAtomComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.classes());
          }
        },
        dependencies: [NgClass],
        styles: ["[_ngcontent-%COMP%]:root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root{--base-font-feature-settings: \"ss01\" on, \"liga\" off, \"clig\" off}.linear-progress-atom[_ngcontent-%COMP%]{height:6px;border-radius:3px}.linear-progress-atom.default[_ngcontent-%COMP%]{background-color:var(--onelevated-shade-80)}"],
        changeDetection: 0
      });
    }
  }
  return NgxLinearProgressAtomComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxLinearStepComponent = /*#__PURE__*/(() => {
  class NgxLinearStepComponent {
    constructor() {
      this.type = input('stepsLine');
      this.totalSteps = input(1);
      this.currentStep = input(1);
      this.style = computed(() => ({
        transform: `translateX(${100 - this.currentStep() / this.totalSteps() * 100}%)`
      }));
      this.classes = computed(() => this.type() === 'stepsLine' ? 'step-line' : '');
    }
    static {
      this.ɵfac = function NgxLinearStepComponent_Factory(t) {
        return new (t || NgxLinearStepComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxLinearStepComponent,
        selectors: [["ngx-linear-step"]],
        inputs: {
          type: [i0.ɵɵInputFlags.SignalBased, "type"],
          totalSteps: [i0.ɵɵInputFlags.SignalBased, "totalSteps"],
          currentStep: [i0.ɵɵInputFlags.SignalBased, "currentStep"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 3,
        vars: 4,
        consts: [["dir", "rtl", 1, "ngx-linear-step", "d-flex", "align-items-center", "radius-tiny", "w-100", "gap-tiny", 3, "ngClass"], [1, "current-step", "h-100", "radius-tiny", "surface-brand", "w-100", 3, "style"], [1, "current-step", "h-100", "radius-tiny", "surface-brand", "w-100"], [1, "w-100", 3, "state"]],
        template: function NgxLinearStepComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, NgxLinearStepComponent_Conditional_1_Template, 1, 2, "div", 1)(2, NgxLinearStepComponent_Conditional_2_Template, 2, 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c3, ctx.type() === "simpleLinear"));
            i0.ɵɵadvance();
            i0.ɵɵconditional(1, ctx.type() === "simpleLinear" ? 1 : 2);
          }
        },
        dependencies: [NgxLinearProgressAtomComponent, NgClass],
        styles: ["[_ngcontent-%COMP%]:root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root{--base-font-feature-settings: \"ss01\" on, \"liga\" off, \"clig\" off}.ngx-linear-step[_ngcontent-%COMP%]{height:6px;overflow:hidden}.ngx-linear-step.step-line[_ngcontent-%COMP%]{background-color:var(--onback-shade-80)}.ngx-linear-step.step-line[_ngcontent-%COMP%]   .current-step[_ngcontent-%COMP%]{transform:translate(-100%);transition:all 2s;transition-delay:.25s}.ngx-linear-step.linear[_ngcontent-%COMP%]{background-color:var(--onback-shade-80)}"],
        changeDetection: 0
      });
    }
  }
  return NgxLinearStepComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxStepperComponent = /*#__PURE__*/(() => {
  class NgxStepperComponent {
    constructor() {
      this.fullSize = input(false);
      this.direction = input('rtl');
      this.orientation = input('horizontal');
      this.type = input('circle');
      this.steps = input([]);
      this.size = input('md');
      this.currentStep = input(1);
      this.stepClick = output();
      this.stepperClass = computed(() => this.orientation() === 'horizontal' ? 'flex-row align-items-flex-end gap-small' : 'flex-column align-items-flex-start gap-small');
      this.linearType = computed(() => {
        switch (this.type()) {
          case 'linear':
            return 'simpleLinear';
          default:
            return 'stepsLine';
        }
      });
      this.current = computed(() => this.steps().find((step, index) => index + 1 === this.currentStep()));
      this.showCircleStep = computed(() => this.type() === 'circle' || this.orientation() === 'vertical');
    }
    circleConnector(step, index) {
      return index === this.steps().length - 1 ? undefined : step.connector;
    }
    stepStyle(index) {
      return {
        flex: this.fullSize() && index !== this.steps().length - 1 ? 1 : 'unset',
        width: this.orientation() === 'vertical' ? '100%' : 'unset'
      };
    }
    handleStepClicked(event, id) {
      this.stepClick.emit({
        event,
        id
      });
    }
    static {
      this.ɵfac = function NgxStepperComponent_Factory(t) {
        return new (t || NgxStepperComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxStepperComponent,
        selectors: [["ngx-stepper"]],
        inputs: {
          fullSize: [i0.ɵɵInputFlags.SignalBased, "fullSize"],
          direction: [i0.ɵɵInputFlags.SignalBased, "direction"],
          orientation: [i0.ɵɵInputFlags.SignalBased, "orientation"],
          type: [i0.ɵɵInputFlags.SignalBased, "type"],
          steps: [i0.ɵɵInputFlags.SignalBased, "steps"],
          size: [i0.ɵɵInputFlags.SignalBased, "size"],
          currentStep: [i0.ɵɵInputFlags.SignalBased, "currentStep"]
        },
        outputs: {
          stepClick: "stepClick"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 3,
        vars: 3,
        consts: [[1, "d-flex", 3, "ngClass", "dir"], [3, "size", "info", "type", "node", "direction", "connector", "style"], [3, "click", "size", "info", "type", "node", "direction", "connector"], [1, "d-flex", "flex-column", "w-100", "gap-minus"], ["type", "horizontal", 3, "title", "showDescription", "placeHolder2", "description"], [3, "type", "totalSteps", "currentStep"]],
        template: function NgxStepperComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, NgxStepperComponent_Conditional_1_Template, 2, 0)(2, NgxStepperComponent_Conditional_2_Template, 3, 7);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.stepperClass())("dir", ctx.direction());
            i0.ɵɵadvance();
            i0.ɵɵconditional(1, ctx.showCircleStep() ? 1 : 2);
          }
        },
        dependencies: [NgxCircleStepComponent, NgxLinearStepComponent, NgClass, NgxInfoComponent],
        styles: ["[_nghost-%COMP%]{width:100%;flex:1}*[_ngcontent-%COMP%]{box-sizing:border-box}"],
        changeDetection: 0
      });
    }
  }
  return NgxStepperComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class CircleNodeModel {}

/**
 * Generated bundle index. Do not edit.
 */

export { CircleNodeModel, NgxStepperComponent };
